import React from 'react';

interface ContainerProps {
  fluid?: boolean;
  className?: string;
  children?: React.ReactNode;
  'aria-label'?: string;
  style?: React.CSSProperties;
}

function Container({ fluid, className = '', children, ...rest }: ContainerProps) {
  const base = fluid ? 'w-full' : 'container mx-auto';
  return (
    <div className={`${base} ${className}`.trim()} {...rest}>
      {children}
    </div>
  );
}

export default Container;
